import { useMemo } from "react";

import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";

import { GET_DEPLOYMENT_FREQUENCY_RATE } from "./gql";

type UseGetDeploymentFrequencyRateProps = {
  startTimeUnix: number;
  endTimeUnix: number;
};

const useGetDeploymentFrequencyRate = ({
  startTimeUnix,
  endTimeUnix,
}: UseGetDeploymentFrequencyRateProps) => {
  const { data, loading, error, refetch, networkStatus, previousData } = usePolledQuery(
    GET_DEPLOYMENT_FREQUENCY_RATE,
    {
      variables: {
        input: {
          startTime: startTimeUnix,
          endTime: endTimeUnix,
          timezone: null,
        },
      },
      pollingGroup: PollingIntervalGroups.Dashboard,
    }
  );

  // Returns deployments per day as a float, undefined when no data yet
  const rate = useMemo(() => {
    return (
      data?.metricsRange?.deploymentFrequencyRateValue?.[0]?.value ??
      previousData?.metricsRange?.deploymentFrequencyRateValue?.[0]?.value
    );
  }, [data, previousData]);

  return {
    rate,
    loading,
    error,
    refetch,
    networkStatus,
  };
};

export default useGetDeploymentFrequencyRate;
